import { render, staticRenderFns } from "./ContactFound.vue?vue&type=template&id=2aa2b39b&"
import script from "./ContactFound.vue?vue&type=script&lang=js&"
export * from "./ContactFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports